<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'Statuses/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'StatusesIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'Statuses' */ './ModalNew')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
